import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

export enum BorderRadius {
  None = 0,
  Small = 2,
  Medium = 4,
  Large = 8,
}

@Component({
  selector: 'rt-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.border-radius]': 'borderRadiusInPixels',
    '[class.no-max-width]': '!limitedWidth',
    '[class.no-shadow]': 'noShadow',
    '[class]': 'variant',
  },
})
export class DropdownComponent {
  public static readonly VARIANTS: Variants = ['default', ['default', 'rtl', 'long', 'white']];
  @ComponentVariant(DropdownComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public set borderRadius(value: BorderRadius) {
    this.borderRadiusInPixels = `${value}px`;
  }
  @Input() public limitedWidth: boolean = true;
  @Input() public contextAlt: boolean = true;
  @Input() public noShadow: boolean = false;

  public borderRadiusInPixels: string = `${BorderRadius.Medium}px`;
}
